export default __webpack_public_path__ + "static/lutein-eye-exam-6c97db787223677f7c0ed629c8831254.jpg";